import { Component, computed, input } from '@angular/core';
import { clamp } from 'lodash';

type SpinnerColor = 'blue' | 'white' | 'black' | 'current';

@Component({
  selector: 'onyx-spinner',
  templateUrl: './onyx-spinner.component.html',
  styleUrl: './onyx-spinner.component.scss',
})
export class OnyxSpinnerComponent {
  public readonly color = input<SpinnerColor>('blue');
  public readonly size = input(24);

  protected strokeWidth = computed(() => {
    const strokePx = clamp(this.size() / 12, 1.5, 3);
    return (strokePx * 24) / this.size();
  });
}
